<template>
  <v-app>
    <v-app-bar app elevation="0" class="white">
      <v-btn class="mr-5" elevation="0" :to="{ name: 'dashboard' }">Monitoring</v-btn>
      <v-btn class="mr-5" elevation="0" :to="{ name: 'reports' }">Reports</v-btn>
      <v-spacer/>
      <v-btn v-if="$route.name === 'dashboard'" class="mr-5" elevation="0" color="primary" outlined @click="refresh">Refresh</v-btn>
      <v-btn color="error" dark @click="logout">
        <span>Logout</span>
      </v-btn>
    </v-app-bar>
    <v-main>
      <router-view ref="view"/>
    </v-main>
    <v-footer dark class="px-0 py-0">
      <v-col class="text-center" cols="12">
        <small>
          &copy; {{ new Date().getFullYear() }}, <b>Leader</b>.
          All rights reserved.
        </small>
      </v-col>
    </v-footer>
  </v-app>
</template>

<script>
export default {
  name: 'MainLayout',
  data: () => ({}),
  methods: {
    async logout () {
      await this.$store.dispatch('logout')
    },
    async refresh () {
      if (this.$refs.view.fetchData) {
        this.$refs.view.fetchData()
      }
    }
  }
}
</script>

<style scoped lang="scss">
.v-btn {

  &.v-btn {

    &--has {

      &-bg {

        //background: #fff !important;
        //border-color: #fff !important;
      }
    }
  }

  &--active {

    &::before {
      background: #fff;
    }

    &.v-btn {

      &--has {

        &-bg {
          background: rgba(243, 182, 63, 0.26) !important;
          border-color: rgba(243, 182, 63, 0.26) !important;
        }
      }
    }
  }
}
</style>
